<template>
  <v-card v-if="editedItem">
    <v-card-title>
      <span class="text-h5">{{ $t('admin.users.editUser') }}</span>
    </v-card-title>

    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="email"
              disabled
              :label="$t('admin.users.email')"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
            <v-col>
              <v-text-field
                v-model="username"
                :label="$t('admin.users.username')"
              >
              </v-text-field>
            </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-text-field
              v-model="firstName"
              :label="$t('admin.users.firstName')"
            >
            </v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="lastName"
              :label="$t('admin.users.lastName')"
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="reset"> {{$t('forms.cancel')}} </v-btn>
      <ApolloMutation
        :mutation="(gql) => updateUserProfileQuery"
        :variables="{
          id: editedItem.userProfile.id,
          username: username,
          firstName: firstName,
          lastName: lastName,
        }"
        @done="reset"
      >
        <template v-slot="{ mutate, loading, error }">
          <v-btn :loading="loading" color="blue darken-1" @click="mutate">
            {{ $t('forms.save')}}
          </v-btn>
          {{ error }}
        </template>
      </ApolloMutation>
    </v-card-actions>
  </v-card>
</template>
<script>
import { UPDATE_USER_PROFILE } from "@/graphql/UserQueries";
export default {
  props: {
    availableRoles: Array,
    editedItem: Object,
  },
  data () {
    return {
      email: { ...this.editedItem}.email,
      firstName: { ...this.editedItem}.userProfile.firstName,
      lastName: { ...this.editedItem}.userProfile.lastName,
      username: { ...this.editedItem}.userProfile.username,
    };
  },
  watch: {
    email(newValue) {
      this.$emit('email', newValue)
    },
    roles(newValue) {
      this.$emit('roles', newValue)
    },
  },
  computed: {
    updateUserProfileQuery() {
      return UPDATE_USER_PROFILE;
    },
  },
  methods: {
    reset() {
      this.$emit("reset");
    },
  }
}
</script>
